<template>
    <el-container class="openClfxx">
        <el-main>
            <el-card class="box-card" shadow="never">
                <div slot="header" class="">
                    <div class="headSecond">{{fwxxList.XQMC}}</div>
                </div>
                <el-col :span="11">
                    <template>
                        <el-carousel :interval="5000" arrow="always" >
                            <el-carousel-item v-for="item in clfImgList">
                                <el-image class="imgClf"
                                          :src="item.imgurl"
                                          :preview-src-list="srcList"
                                ></el-image>
                            </el-carousel-item>
                        </el-carousel>
                    </template>
                </el-col>
                <el-col :span="12" :offset="1">
                    <el-row>
                        <el-col :span="18">
                            <el-row>
                                <span class="SpancontentFyhybm">
                                    房源核验唯一编码
                                </span>
                            </el-row>
                            <el-row class="SpancontentFyhyrow">
                                <span class="SpancontentFyhy">
                                    {{fwxxList.FYHYBM}}
                                </span>
                            </el-row>
                        </el-col>
                        <el-col :span="6" @click.native="downloadQRCode('fwQRCode')">
                            <!-- <el-row class="ERMDIV">
                                <el-image class="imgEWM"
                                          :src="fwxxList.imgUrl"
                                ></el-image>
                            </el-row> -->
							<div class="qrcode" id="fwQRCode" ref="fwQRCode"></div>
                            <el-row class="wzEWM ERMDIV">
                                点击下载二维码
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <div>
                        <el-row>
                            <el-col :span="10" class="Spanfwzj">
                                <span>
                                    {{fwxxList.FWZJ}}元
                                </span>
                            </el-col>
                            <el-col :span="14" class="SpanFwdz">
                                <span >
                                     {{fwxxList.FWDZ}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <span class="Spancontent1">
                                    所属城区
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.SSCQ}}
                                </span>
                            </el-col>
                            <el-col :span="12">
                                <span class="Spancontent1">
                                    用途类型
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.YTLX}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <span class="Spancontent1">
                                    建筑面积
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.JZMJ}}
                                </span>
                            </el-col>
                            <el-col :span="12">
                                <span class="Spancontent1">
                                    挂牌时间
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.GPSJ}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <span class="Spancontent1">
                                    所在楼层
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.SZLC}}
                                </span>
                            </el-col>
                            <el-col :span="12">
                                <span class="Spancontent1">
                                    装修程度
                                </span>
                                <span class="Spancontent2">
                                    {{fwxxList.ZXCD}}
                                </span>
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>
                    </div>
                    <div>
                        <el-col :span="6">
                            <el-image class="imgJJR"
                                      :src="jjryList.JJRPHOTO"
                            ></el-image>
                        </el-col>
                        <el-col :span="12">
                            <el-row>
                                <span class="jjrgrmc">
                                    {{jjryList.GRMC}}
                                </span>
                            </el-row>
                            <el-row>
                                <span class="Spancontent1">
                                    经纪人编号
                                </span>
                                <span class="Spancontent2">
                                    {{jjryList.ZJHM}}
                                </span>
                            </el-row>
                            <el-row>
                                <span class="Spancontent1">
                                    从业时间
                                </span>
                                <span class="Spancontent2">
                                    {{jjryList.CYSJ}}
                                </span>
                            </el-row>
                        </el-col>
                        <el-col :span="6" @click.native="downloadQRCode('jjrQRCode')">
                            <!-- <el-row class="ERMDIV">
                                <el-image class="imgEWM"
                                          :src="fwxxList.imgUrl"
                                ></el-image>
                            </el-row> -->
							<div class="qrcode" id="jjrQRCode" ref="jjrQRCode"></div>
                            <el-row class="wzEWM ERMDIV">
                                点击下载二维码
                            </el-row>
                        </el-col>
                    </div>
                </el-col>
            </el-card>
            <el-divider class="clfxxDivider"></el-divider>
            <!--挂牌机构信息-->
            <el-card class="box-card" shadow="never">
                <div slot="header" class="clearfix">
                    <div class="headSecond">挂牌机构信息</div>
                </div>
                <el-row>
                    <el-table
                            :data="tableData"
                            style="width: 100%"
                            :header-cell-class-name="ClassName_Biaotou"
                            :row-class-name="tableRowClassName">
                        <el-table-column
                                prop="jgmc"
                                align="center"
                                label="挂牌机构名称"
                                width="260">
                        </el-table-column>
                        <el-table-column
                                prop="babh"
                                align="center"
                                label="备案编号"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="lxdh"
                                align="center"
                                label="联系电话">
                        </el-table-column>
                        <el-table-column
                                prop="mddz"
                                align="center"
                                label="门店地址">
                        </el-table-column>
                        <el-table-column
                                prop="qtgpjgs"
                                align="center"
                                label="其它挂牌数">
                        </el-table-column>
                    </el-table>
                </el-row>
            </el-card>

            <!--风险提示-->
            <el-card class="box-card" shadow="never">
                <div slot="header" class="clearfix">
                    <div class="headSecond">风险提示</div>
                </div>
                <el-row class="fxts">
                    1、本平台挂牌的拟售价格仅供参考,实际成交价格由买卖双方自行协商.
                </el-row>
                <el-row class="fxts">
                    2、本平台发布的房屋图片由经纪机构或出售人提供,仅供参考,购房者请务必实地查看房屋真实情况.
                </el-row>
                <el-row class="fxts">
                    3、本平台挂牌房屋如为共有的,签订房屋买卖合同时,须由全体房屋所有权人到现场签字同意.
                </el-row>
                <el-row class="fxts">
                    4、挂牌房屋存在抵押情形的,办理房屋交易确认手续前,应先办理完毕抵押注销登记.
                </el-row>
                <el-row class="fxts">
                    5、挂牌房屋已出租的,签订房屋买卖合同时,应确保承租人已放弃优先购买权.
                </el-row>
                <el-row class="fxts">
                    6、本平台挂牌房屋成交后应按规定签订房屋买卖合同,办理房屋交易确认及不动产登记手续,所需资料及办理条件以法律法规规定及主管部门的要求为准.
                </el-row>

            </el-card>
        </el-main>
    </el-container>
</template>

<script>
	import QRCode from 'qrcodejs2'
	import axios from 'axios';
	import config from "@/config";
	const base_url = config.baseUrl + 'clf/';
    export default {
        name: "openClfxx",
        data() {
            const item = {
                jgmc: '汉中鸿润置业有限公司',
                babh: 'H20210000234',
                lxdh: 'H20210000234',
                mddz:'H20210000234',
                qtgpjgs:'0',
            };
            return {
				fyhybm: null,
                tableData: [],
                fwxxList:{
                },
                jjryList:{
                },
                clfImgList:[
                    {imgurl: require("../../img2/clf/zwtp.png")},
                    {imgurl: require("../../img2/clf/zwtp.png")},
                ],
                srcList: [
                    require("../../img2/clf/zwtp.png"),
                    require("../../img2/clf/zwtp.png")
                ],
            }
        },
        methods: {
            warnMessage(obj) {
                this.$alert(obj, '温馨提示', {
                    confirmButtonText: '确定',
                });
            },
            tableRowClassName({row, rowIndex}) {
                if ( rowIndex%2 ==0) {
                    return 'success-row';
                } else if (rowIndex%2 !=0) {
                    return '';
                }
                return '';
            },
            ClassName_Biaotou({row, column, rowIndex, columnIndex}) {
                    return 'class_Biaotou';
            },
			createJJRQRCode(text) {
				var qrcode = new QRCode(this.$refs.jjrQRCode, {
					text: text,
					width: 143,
					height: 143,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
			},
			createFWQRCode(text) {
				var qrcode = new QRCode(this.$refs.fwQRCode, {
					text: text,
					width: 143,
					height: 143,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
			},
			downloadQRCode(type) {
				const tag = document.createElement('a');
				tag.setAttribute('download', type + '.jpg');
				const url = document.getElementById(type).getElementsByTagName('img')[0].src;
				tag.href = url;
				tag.click();
			}
        },
        created() {
			this.fyhybm = this.$route.query.fyhybm;
			axios.get(base_url + "clfxx_fwxx" + "?fyhybm=" + this.fyhybm).then(response => {
				const fwQRCodeUrl = window.location.origin + '/ywhome/clfhome/openClfxxByEWM?fyhybm=' + this.fyhybm;
				this.createFWQRCode(fwQRCodeUrl);
				response.data.FWZJ = response.data.FWZJ.toString().replace(/\B(?=(\d{3})+$)/g,',');
				this.fwxxList = response.data;
			}).catch(error => console.log(error, "error"));
			axios.get(base_url + "clfxx_jjry" + "?fyhybm=" + this.fyhybm).then(response => {
				const jjrQRCodeUrl = window.location.origin + '/ywhome/clfhome/ClfopenJjrxx?grxh=' + response.data.grxh;
				this.createJJRQRCode(jjrQRCodeUrl);
				response.data.JJRPHOTO = require("/src/" + response.data.JJRPHOTO);
				this.jjryList = response.data;
			}).catch(error => console.log(error, "error"));
			axios.get(base_url + "clfxx_gpjg" + "?fyhybm=" + this.fyhybm).then(response => {
				this.tableData = response.data;
			}).catch(error => console.log(error, "error"));
			
			
        },
    }
</script>

<style scoped>
    @import "../../assets/css/clf/openClfxx.css";

    .el-main{
        background: #fff !important;
    }
</style>